import { Flex, FormLabel, Switch } from '@chakra-ui/react';

export const ControlToggle = ({
    label,
    isChecked,
    onChange,
}: {
    label: string;
    isChecked: boolean;
    onChange: (checked: boolean) => void;
}) => (
    <Flex
        flexDirection="row"
        alignItems="center"
        width="fit-content"
        borderRadius="md"
        borderWidth={1}
        flexShrink={0}
        px={2}
        h={8}
    >
        <Switch mr={2} onChange={(ev) => onChange(ev.target.checked)} isChecked={isChecked} />
        <FormLabel m={0} p={0} fontSize="sm">
            {label}
        </FormLabel>
    </Flex>
);
